import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { confirmDialog } from "primereact/confirmdialog";
import { Checkbox } from "primereact/checkbox";

// ------------------ COMPONENTES DE BASE--------------------------------
import Card from "../../../../../Base/Components/Card/Card";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import Loader from "../../../../../Base/Components/Loader/Loader";
import AgGrid from "../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../../../Base/Services/Config/ConfigService";
import { toastShow } from "../../../../../Base/Services/ToastService";
import { getLabel } from "../../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../../Base/Context/ConfigContext/ConfigContext";

// ------------------- CONSULTAS A LA API--------------------------------
import { getAprobarRequisa } from "../../../../../API/Compras/Requisas/AprobarRequisa/AprobarRequisaRequest";
import {
  ChangeAuth,
  getAutorizaciones,
} from "../../../../../API/Compras/Autorizaciones/AutorizacionesRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import CrudRequisa from "../CrudRequisa/CrudRequisa";
import { useLocation } from "react-router-dom";

const AprobarRequisasScreen = () => {
  const toast = useRef(null);
  // const tableRef = useRef(null);
  const { userAuth } = useContext(AuthContext);
  const { config } = useContext(ConfigContext);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [rowEdit, setRowEdit] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const [display, setDisplay] = useState(false);
  const [password, setPassword] = useState("");
  const [permiso, setPermiso] = useState(null);
  const [user, setUser] = useState(null);
  const [Autorizaciones, setAutorizaciones] = useState([]);
  const [habilitar, setHabilitar] = useState(true);
  const location = useLocation();
  const Referencia = location.state?.Referencia;

  // // ACCESOS DE LIBERAR BODEGA
  // const [hiddenliberarBodega, setHiddenLiberarBodega] = useState(
  //   userAuth.AccessWeb.split(",")
  //     .map((e) => parseInt(e))
  //     .includes(33)
  // );

  // // ACCESO DE LIBERAR REQUISA COMPRAS - GERENTE AREA
  // const [hiddenliberarRequisa, setHiddenLiberarRequisa] = useState(
  //   userAuth.AccessWeb.split(",")
  //     .map((e) => parseInt(e))
  //     .includes(27)
  // );

  // ACCESO APROBAR REQUISA FINANZAS
  const [hiddenAprobarRequisaFinanzas, setHiddenAprobarRequisaFinanzas] =
    useState(
      userAuth.AccessWeb.split(",")
        .map((e) => parseInt(e))
        .includes(30),
    );

  // ACCESO APROBAR REQUISA GERENTE PLANTA
  const [
    hiddenAprobarRequisaGerentePlanta,
    setHiddenAprobarRequisaGerentePlanta,
  ] = useState(
    userAuth.AccessWeb.split(",")
      .map((e) => parseInt(e))
      .includes(32),
  );

  const getInfo = async () => {
    setLoading(true);
    const a = await getAprobarRequisa();
    setData(a);
    setLoading(false);
    const autorizacionesData = await getAutorizaciones();
    setAutorizaciones(
      autorizacionesData.filter((autorizacion) => autorizacion.IdTipo === 7),
    );
  };

  // CAMBIAR FIRMAS DE FINANZAS Y GERENTE PLANTA
  const handleCheckboxChange = async (
    event,
    data,
    IdPermisoGeneral,
    NombrePermiso,
  ) => {
    const dataToSend = data.map((item) => {
      return {
        IdPurcharesRequestDetail: item?.IdPurcharesRequestDetail,
        IdPermisoGeneral: IdPermisoGeneral,
        Autorizo: !item[NombrePermiso],
        IdUsuarioAutorizo: userAuth?.IdUser,
      };
    });
    // const valorCampo = data[0][NombrePermiso];
    confirmDialog({
      message: `¿Está seguro que desea aprobar ${data.length} ${data.length > 1 ? "permisos" : "permiso"}?`,
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",
      accept: async () => {
        const respuestaDetalles = await ChangeAuth(dataToSend);
        if (respuestaDetalles[0]?.ESTADO === 1) {
          toastShow(toast, "success", "Guardado", respuestaDetalles[0].MENSAGE);
          getInfo();
        } else {
          toastShow(toast, "error", "Error", respuestaDetalles[0].MENSAGE);
        }
      },
      reject: () => {},
    });
    setSelected([]);
  };

  const columns = [
    {
      // PurchaseRequest
      field: "IdPurcharesRequestDetail",
      header: "ID",
      headerEn: "ID",
      className: "XXsmall",
      frozen: "frozen",
      hidden: userAuth.IdRol === 1,
    },
    {
      // EstadoPD
      field: "StatusName",
      header: "Estado",
      headerEn: "Status",
      className: "Xsmall",
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
      frozen: "frozen",
      Format: "Estado",
    },
    {
      // PurchaseRequest
      field: "PurchaseRequest",
      header: "No. Requisa",
      headerEn: "No. Requisition",
      className: "small",
      frozen: "frozen",
      Format: "Modal",
      Sumary: "count",
      filter: false,
      initialFilterModel: true,
    },
    {
      // FechaPermiso4
      field: "FechaLiberar",
      header: "Fecha Liberada",
      className: "medium",
      Format: "DateTime",
    },
    {
      // Proveedor
      field: "CustomerName",
      header: "Proveedor",
      headerEn: "Supplier",
      className: "Xlarge",
    },
    {
      field: "CodigoProducto",
      header: "Código Producto",
      headerEn: "Product Code",
      className: "Xsmall",
      frozen: true,
    },
    {
      field: "NombreProducto",
      header: "Producto",
      headerEn: "Product",
      className: "Xlarge",
      frozen: true,
    },
    {
      // UnitSimbol
      field: "UnitName",
      header: "Unidad",
      headerEn: "Unit",
      className: "Xsmall",
      Format: "Center",
    },
    {
      // Quantity
      field: "Inventario",
      header: "Invetario",
      headerEn: "Invetary",
      className: "small",
      Sumary: "sum",
      Format: "Currency",
    },
    {
      // Quantity
      field: "Quantity",
      header: "Cantidad",
      headerEn: "Quantity",
      className: "small",
      Sumary: "sum",
      Format: "Currency",
    },
    {
      // Price
      field: "Price",
      header: "Precio",
      headerEn: "Price",
      className: "small",
      Format: "Currency",
    },
    {
      // ISV
      field: "TAX",
      header: "ISV",
      headerEn: "TAX",
      className: "small",
      Format: "Currency",
    },
    {
      // Descuento
      field: "Discount",
      header: "Descuento",
      headerEn: "Discount",
      className: "small",
      Format: "Currency",
    },
    {
      // SubTotal
      field: "SubTotal",
      header: "SubTotal",
      className: "small",
      Sumary: "sum",
      Format: "Currency",
    },
    {
      // Total
      field: "Total",
      header: "Total",
      className: "small",
      Sumary: "sum",
      Format: "Currency",
    },
    {
      // CurrencySymbol
      field: "Currency",
      header: "Moneda",
      headerEn: "Currency",
      className: "Xsmall",
      Format: "Center",
    },
    {
      // Comment
      field: "Comment",
      header: "Comentarios",
      headerEn: "Comment",
      className: "XXlarge",
      body: (rowData) => rowData.Comment,
    },
    {
      // Description
      field: "Description",
      header: "Decripción",
      headerEn: "Description",
      className: "XXlarge",
      body: (rowData) => rowData.Description,
    },
    {
      // RequestType
      field: "Type",
      header: "Tipo Requisa",
      headerEn: "Requisition Type",
      className: "small",
      body: (rowData) => rowData.RequestType,
    },
    {
      // Priority
      field: "Priority",
      header: "Prioridad",
      headerEn: "Priority",
      className: "Xsmall",
      body: (rowData) => ({ ID: rowData.Priority, Estado: rowData.Priority }),
      Format: "Estado",
    },
    {
      // AgentName
      field: "UserNameAgente",
      header: "Asignado a",
      headerEn: "Assigned To",
      className: "large",
    },
    {
      // Area
      field: "Area",
      header: "Área",
      headerEn: "Area",
      className: "medium",
    },
    {
      // DateCreated
      field: "DateCreated",
      header: "Fecha Creada",
      headerEn: "Date Create",
      className: "large",
      Format: "DateTime2",
    },
    {
      // Dias
      field: "Dias",
      header: "Dias",
      headerEn: "Days",
      className: "Xsmall",
      Format: "Dias",
    },
    {
      // TipoSuministro
      field: "NombreTipoProducto",
      header: "Tipo",
      headerEn: "Type",
      className: "small",
    },
    {
      // TotalL
      field: "TotalL",
      header: "Lempiras",
      className: "small",
      Sumary: "sum",
      Format: "Currency",
    },
    {
      // TotalD
      field: "TotalD",
      header: "Dolares",
      className: "small",
      Sumary: "sum",
      Format: "Currency",
    },
    {
      // TotalE
      field: "TotalE",
      header: "Euros",
      className: "small",
      Sumary: "sum",
      Format: "Currency",
    },
    {
      // ASolicita
      field: "UserName",
      header: "Solicita",
      headerEn: "Request",
      className: "large",
    },
    {
      // NombreCategoria
      field: "NombreCategoria",
      header: "Categoria",
      headerEn: "Category",
      className: "large",
    },
    {
      // FechaPermiso1
      field: "FechaLiberar",
      header: "Fecha Auth Gerente",
      className: "large",
      Format: "DateTime",
    },
    {
      // FechaPermiso1
      field: "FechaAutorizoFinanzas",
      header: "Fecha Finanzas",
      className: "large",
      Format: "DateTime",
    },
    {
      // FechaPermiso3
      field: "FechaAutorizoPlanta",
      header: "Fecha  P. Manager",
      className: "large",
      Format: "DateTime",
    },
    {
      // FechaCotizacion
      field: "FechaCotizacion",
      header: "Fecha Precio",
      headerEn: "Date Create",
      className: "large",
      Format: "DateTime",
    },
    {
      // Quantity
      field: "Quantity",
      header: "Cantidad",
      headerEn: "Quantity",
      className: "small",
      Sumary: "sum",
      Format: "Currency",
      frozen: true,
      alignFrozen: "right",
    },
    {
      // CurrencySymbol
      field: "CurrencySymbol",
      header: "Moneda",
      headerEn: "Currency",
      className: "XXsmall",
      Format: "Center",
      frozen: true,
      alignFrozen: "right",
    },
    {
      // Total
      field: "Total",
      header: "Total",
      className: "small",
      Sumary: "sum",
      Format: "Currency",
      frozen: true,
      alignFrozen: "right",
    },
    ...Autorizaciones.map((autorizacion) => {
      return {
        field: autorizacion?.NombrePermiso,
        header: autorizacion.NombrePermiso,
        frozen: true,
        alignFrozen: "right",
        align: "center",
        className: "Xsmall",
        Format: "Template",
        filter: false,
        hidden:
          (autorizacion.IdPermisoGeneral !== 2 &&
            hiddenAprobarRequisaFinanzas) ||
          (autorizacion.IdPermisoGeneral !== 1 &&
            hiddenAprobarRequisaGerentePlanta),
        body: (rowData) => {
          return rowData.IdPurcharesRequestDetail ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                paddingTop: "2px",
              }}
            >
              <Checkbox
                checked={rowData[autorizacion?.NombrePermiso] === 1}
                onChange={(event) => {
                  if (
                    autorizacion?.IdPermisoGeneral === 1 ||
                    autorizacion?.IdPermisoGeneral === 2
                  ) {
                    if (selected.length === 0) {
                      handleCheckboxChange(
                        event,
                        [rowData],
                        autorizacion?.IdPermisoGeneral,
                        autorizacion.NombrePermiso,
                      );
                    } else {
                      handleCheckboxChange(
                        event,
                        selected,
                        autorizacion?.IdPermisoGeneral,
                        autorizacion.NombrePermiso,
                      );
                    }
                  }
                }}
              />
            </div>
          ) : null;
        },
      };
    }),
  ];

  const table = {
    Columns: columns,
    Data: data,
    Loading: loading,
    selected: selected,
    setSelected: setSelected,
    showModal: (e) => showModal(e),
    initialFilterModel: Referencia
      ? {
          PurchaseRequest: {
            type: "equals",
            filter: Referencia,
          },
        }
      : null,
  };

  const showModal = (purchaseRequest) => {
    setRowEdit(purchaseRequest);
    setShowDialog(true);
  };

  const onHide = () => {
    setDisplay(false);
    setPassword("");
    setRowEdit(null);
    setPermiso(null);
    setSelected([]);
    setShowDialog(false);
  };

  const cerrarConfirmacion = () => {
    // Mostrar confirmación si hay ediciones sin guardar
    if (habilitar && rowEdit !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          onHide(); // Cerrar el diálogo
        },
        rejectLabel: "No",
        reject: () => {}, // No hacer nada si el usuario cancela
        style: { backgroundColor: "white" },
      });
    } else {
      onHide();
    }
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "aprobarRequisa", config.language));
    setUser(userAuth.Usuario);
    if (user) {
      getInfo();
    }
  }, [user]);

  return (
    <div>
      <Loader loading={loading} />
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones">
            <h2>{getLabel(baseLang, "aprobarRequisa", config.language)}</h2>
            <Button icon="pi pi-search" onClick={getInfo} />
            {/* {userAuth.IdRol === 1 && <div className='d-flex gap' style={{ alignItems: 'center', gap: 10}}>
                        <label className='mr-2'>Plant Manager Filter</label>
                        <InputSwitch
                            checked={user === 'luise'}
                            onChange={(e) => setUser(e.value ? 'luise' : 'imatamoros')}
                        />
                        <label className='mr-2'>Accounting Filter</label>
                    </div>} */}
          </div>
        }
        contenido={
          <div className="pt-3 mt-2" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />
      <Dialog
        visible={showDialog}
        onHide={() => {
          cerrarConfirmacion();
        }}
        maximizable
        closeOnEscape={false}
        maximized={true}
      >
        <CrudRequisa
          idRequisa={rowEdit}
          setRequisaToShow={setRowEdit}
          showDialog={showDialog}
          actualizarRequisasScreen={getInfo}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
        />
      </Dialog>
    </div>
  );
};

export default AprobarRequisasScreen;
